<template>
  <sweet-modal ref="modal" overlay-theme="dark">
    <div v-if="professional">
      <div class="text-left p-3 text-comment">
        <cleaner-profile-mobile :isActiveReviewLink="false" :professional="professional"/>
        <cleaner-description-section :professional="professional"/>
        <hr class="mb-0">
        <div class="pt-4">
          <cleaner-reviews-section ref="professionalReviews" />
        </div>
      </div>
      <div class="modal-footer-test bg-white border-top py-3 text-right">
        <div class="alert alert-info text-left" role="alert" v-if="isLoading">
          <h4 class="mb-0">
            {{ $t('message.booking.switch_professional.processing_switch_professional') }}
            <span class="text-info"><i class="fas fa-spinner fa-pulse"></i></span>
          </h4>
        </div>
        <button class="btn btn-info btn-block" 
                :disabled="isLoading"
                @click="displayConfirmDialog">
          {{ isLoading ?  $t('message.button.loading') : $t('message.booking.switch_professional.button') }}
        </button>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'
  import CleanerProfileMobile from '../../professional/components/CleanerProfileMobile'
  import CleanerDescriptionSection from '../../professional/components/CleanerDescriptionSection'
  import CleanerReviewsSection from '../../professional/components/CleanerReviewsSection'
  import axios from 'axios'

  export default {
    components: {
      SweetModal,
      CleanerProfileMobile,
      CleanerDescriptionSection,
      CleanerReviewsSection
    },
    data () {
      return {
        orderId: null,
        professionalId: null,
        isLoading: false
      }
    },
    computed: {
      ...mapGetters({
        professional: 'professional/getProfessional',
        user: 'auth/getUser'
      })
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      async showModal (payload) {
        this.orderId = payload.orderId
        this.professionalId = payload.professionalId
        this.$refs.modal.open()

        // Fetch professional detail
        await this.$store.dispatch('professional/LOAD_PROFESSIONAL_DETAIL', { professional_id: this.professionalId })

        // Fetch professional reviews
        this.$refs.professionalReviews.loadFirstReviews()
      },
      displayConfirmDialog () {
        if (this.professional) {
          this.$swal({
            title: this.$i18n.t('message.booking.switch_professional.confirm_dialog_title'),
            html: `${this.$i18n.t('message.booking.switch_professional.confirm_dialog_detail')}<br><br>
            ${this.$i18n.t('message.booking.switch_professional.selected_professional')} 
            <font color="#00ACC1">${this.$options.filters.firstName(this.professional.name)}</font>`,
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonColor: '#17a2b8',
            confirmButtonText: this.$i18n.t('message.button.confirm'),
            cancelButtonText: this.$i18n.t('message.button.back')
          }).then((result) => {
            if (result) {
              this.confirmOrderByUser()
            }
          })
        }
      },
      async confirmOrderByUser () {
        this.isLoading = true
        const url = `professional/orders/${this.orderId}/confirm`
        const submitData = {
          user_id: this.user.id,
          professional_id: this.professional.id
        }
        const { data } = await axios.post(url, submitData)
        this.isLoading = false
        if (!data.error) {
          this.$refs.modal.close()
          this.loadOrderDetail(this.orderId)
          this.$swal({ text: this.$i18n.t('message.booking.switch_professional.success'), type: 'success' })
        } else {
          this.$swal({ text: data.message, type: 'error' })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/ProfessionalDetailModal.vue